import { useEventListener } from "@vueuse/core";

function findContextMenuTrigger(e: PointerEvent): Element | undefined {
  const body = document.body;

  // Try find an element under the cursor
  // because `document.elementFromPoint` is affected by pointer-events:none,
  // we disable it on the body element and then restore it back
  const bodyPointerEvents = body.style.pointerEvents;

  try {
    body.style.pointerEvents = "";

    const elementAt = document.elementFromPoint(e.clientX, e.clientY);
    if (!elementAt) {
      return undefined;
    }

    const contextMenu = elementAt.closest("[data-axure-context-menu-trigger]");
    if (contextMenu) {
      return contextMenu;
    }
  } finally {
    body.style.pointerEvents = bodyPointerEvents;
  }
}

export function useContextMenuGuard() {
  useEventListener("contextmenu", e => {
    const targetElement = e.target as HTMLElement | null;
    if (!targetElement || !(targetElement instanceof HTMLElement)) {
      return;
    }

    const body = document.body;
    const htmlOrBodyTarget = e.target === document.documentElement || e.target === body;
    if (!htmlOrBodyTarget) {
      return;
    }

    const isRekaModalPopper = body.style.pointerEvents === "none";
    if (!isRekaModalPopper) {
      return;
    }

    // Test if we can find an element under the cursor and dispatch contextmenu event on it
    const contextMenu = findContextMenuTrigger(e);
    if (contextMenu) {
      contextMenu.dispatchEvent(new PointerEvent("contextmenu", e));
    }

    // prevent default context menu on html/body
    e.preventDefault();
  });
}
